import React, { useState } from 'react';
import {
    Row,
    Col,
    Divider,
    Typography,
    Skeleton,
    Result,
    Table,
    Input,
    Space,
    message,
    Button
} from 'antd';
// import {
//     FaPlusCircle,
//     FaPrint
// } from "react-icons/fa";

import { useParams } from 'react-router-dom';
import {
    useQuery,
    useMutation,
    useQueryClient
} from '@tanstack/react-query';
// import { useReactToPrint } from 'react-to-print';
// import axios from '../../config/axios';
import dayjs from 'dayjs';
import CheckSwitch from './components/CheckSwitch';
import axios from '../../config/axios';


const columns = [
    {
        title: 'Check',
        dataIndex: 'is_attent',
        key: 'is_attent',
        render: (text, option) => <CheckSwitch isCheck={text} attItemsId={option._id} />
    },
    {
        title: 'ID',
        dataIndex: 'student',
        key: 'student',
        render: (text, _) => text.student_code
    },
    {
        title: 'Firstname',
        dataIndex: 'student',
        key: 'student',
        render: (text, _) => text.fname_th
    },
    {
        title: 'Lastname',
        dataIndex: 'student',
        key: 'student',
        render: (text, _) => text.lname_th
    },
    {
        title: 'Nickname',
        dataIndex: 'student',
        key: 'student',
        render: (text, _) => text.nick_name ?? "-"
    },

]
function Detail() {

    const [studentData, setStudentData] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();
    const { id } = useParams();
    const attendanceQuery = useQuery({ queryKey: [`/api/attendance/${id}`] });
    const courseStudentsQuery = useQuery({ queryKey: [`/api/attendance/attendanceStudents/${id}`] });
    const queryClient = useQueryClient();
    const { isLoading, mutate } = useMutation({
        mutationFn: data => {
            // console.log(data);
            axios
                .post(`/api/attendance/createByIdOrPhone`, data)
                .then(res => {
                    messageApi.open({
                        type: 'success',
                        content: 'Create successfully',
                        duration: 1,
                        onClose: () => {
                            queryClient.invalidateQueries([`/api/attendance/attendanceStudents/${id}`]);
                        }
                    });
                })
                .catch(err => {
                    console.log(err)
                    messageApi.open({
                        type: 'error',
                        content: 'Create failed!',
                    });
                })
        },
    });

    // const onPrint = useReactToPrint({
    //     content: () => componentRef.current,
    //     documentTitle: orderQuery?.data?.order_no
    // });

    if (
        attendanceQuery.isLoading
        || courseStudentsQuery.isLoading
    ) {
        return <Skeleton active />
    }

    if (
        attendanceQuery.isError
        || courseStudentsQuery.isError
    ) {
        return <Result
            status="error"
            title={
                attendanceQuery.error.message
                || courseStudentsQuery.error.message
            } />
    };

    const onInputIDOrPhone = e => {
        setStudentData(e.target.value);
    }
    const onCreateAttendance = () => {
        if (!!studentData) {
            mutate({
                attendance_id: id,
                student: studentData,
            })
        };
    }
    // console.log('attendanceQuery.data =', attendanceQuery.data);
    // console.log('courseStudentsQuery.data =', courseStudentsQuery.data);
    return (
        <div style={{
            background: '#fff',
        }}>
            {contextHolder}
            <Row gutter={[16, 16]}>
                <Col xs={24}>
                    <Typography.Title level={3} style={{ margin: '0px', padding: '0px' }}>
                        {attendanceQuery.data.product.name ?? ""}
                    </Typography.Title>
                    <Typography.Title level={4} style={{ margin: '0px', padding: '0px' }}>
                        Date : {dayjs(attendanceQuery.data.check_date).format('DD-MM-YYYY')}
                    </Typography.Title>
                    <Typography.Title level={4} style={{ margin: '0px', padding: '0px' }}>
                        Time : {`${attendanceQuery.data.begin_time.slice(0,5)} - ${attendanceQuery.data.end_time.slice(0,5)}`}
                    </Typography.Title>
                </Col>
                <Col xs={24}>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Typography.Paragraph strong>
                                Description :
                            </Typography.Paragraph>
                        </Col>
                        <Col>
                            <Typography.Paragraph strong>
                                {attendanceQuery.data.description}
                            </Typography.Paragraph>
                        </Col>
                    </Row>
                </Col>
                <Col xs={24}>
                    <Divider />
                </Col>
                <Col xs={24}>
                    <Row justify='space-between'>
                        <Col flex={1}>
                        </Col>
                        <Col xs={24} md={8}>
                            <Space.Compact style={{ width: '100%' }}>
                                <Input
                                    allowClear
                                    placeholder="Input Student ID or Phone" 
                                    onChange={onInputIDOrPhone}
                                    onPressEnter={onCreateAttendance}
                                />
                                <Button
                                    type="primary"
                                    disabled={isLoading}
                                    onClick={onCreateAttendance}>Add</Button>
                            </Space.Compact>

                        </Col>
                    </Row>
                </Col>
                <Col xs={24}>
                    <Table
                        rowKey={(record) => record._id}
                        columns={columns}
                        dataSource={courseStudentsQuery.data}
                        scroll={{
                            x: 800,
                        }}
                    />
                </Col>
                {/* <Col xs={24}>
                    <Form
                        name="createUser"
                        layout="vertical"
                        form={form}
                        initialValues={{
                            ...orderQuery.data,
                            fname_th: orderQuery.data.student?.fname_th,
                            lname_th: orderQuery.data.student?.lname_th,
                            phone: orderQuery.data.student?.phone,
                            parent_phone: orderQuery.data.student?.parent?.phone,
                            order_date: dayjs(orderQuery.data.order_date).isValid() ? dayjs(orderQuery.data.order_date) : null
                        }}
                    >
                        <Row>
                            <Col xs={24} md={16}>
                                <Row gutter={[8, 8]}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Date"
                                            name="order_date"
                                        >
                                            <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}></Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="First Name (ภาษาไทย)"
                                            name="fname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Last Name (Thai)"
                                            name="lname_th"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone Number"
                                            name="phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Parent Phone"
                                            name="parent_phone"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Payment Type"
                                            name="payment_type"
                                        >
                                            <Input />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Vat. Include"
                                            name="is_vat"
                                            valuePropName="checked"
                                        >
                                            <Checkbox />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24}>
                                        <Form.Item
                                            label="Description"
                                            name="description"
                                        >
                                            <Input.TextArea rows={4} />
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Form>
                </Col> */}
                {/* <Col xs={24} md={16}>
                    <OrderItemsDetail orderItems={orderItemsQuery.data} />
                </Col> */}


                {/* <Col xs={24} md={16}>
                    <Row justify='end'>
                        <Col>
                            <Button
                                type="primary"
                                icon={<FaPrint />}
                                onClick={onPrint}
                                style={{
                                    width: '100%',
                                    textTransform: 'capitalize'
                                }}
                            >
                                print
                            </Button>
                        </Col>
                    </Row>

                </Col> */}
            </Row>
            {/* <div style={{ display: "none" }}>
                <Invoice orderData={orderQuery.data} orderItems={orderItemsQuery.data} printRef={componentRef} />
            </div> */}
        </div>
    )
}

export default Detail